export default {
  nav: {
    home: "الرئيسية",
    services: "الخدمات",
    about: "من نحن",
    testimonials: "آراء العملاء",
    contact: "اتصل بنا",
    requestQuote: "تواصل معنا",
  },
  hero: {
    headline: "نجهز مستودعك من الألف إلى الياء",
    subheadline:
      "نقدّم أنظمة تخزين متكاملة للمصانع والشركات، تشمل تصميم، قياس، تصنيع، وتركيب باحترافية لرفع كفاءة المستودع. كل ما تحتاجه في مكان واحد — بأعلى المعايير من البداية حتى التسليم.",
    cta: "تواصل معنا",
    scrollHint: "مرر للأسفل",
  },
  services: {
    sectionTitle: "الخدمات التي نقدمها",
    sectionDesc:
      "نقدم حلول تخزين متكاملة ومبتكرة تلبي احتياجات مختلف القطاعات في المملكة",
    homeProductsEyebrow: "منتجاتنا",
    homeProductsTitle: "منتجان أساسيان يمثلان قوة ابراج الرفوف",
    homeProductsDesc: "نركز على رفوف المستودعات الثقيلة ورفوف السوبر ماركت كخطّين رئيسيين بمرونة عالية في المقاسات والتصميم والتنفيذ.",
    homeProductLabel: "منتج",
    homeProductCta: "عرض التفاصيل",
    warehouseTitle: "رفوف المستودعات الثقيلة",
    warehouseDesc:
      "أنظمة رفوف صناعية عالية السعة مصممة للمستودعات ومراكز التوزيع مع أقصى درجات المتانة والامتثال للسلامة",
    retailTitle: "رفوف عرض التجزئة",
    retailDesc:
      "حلول رفوف تجزئة حديثة مصممة لتعظيم رؤية المنتج وكفاءة تخطيط المتجر",
    supermarketTitle: "حلول السوبر ماركت",
    supermarketDesc:
      "أنظمة رفوف وحلول تخزين كاملة للسوبر ماركت تشمل رفوف الجندول ووحدات التبريد وكوات الخروج",
    card1Title: "تصميم أنظمة التخزين",
    card1Desc: "نقوم بدراسة احتياجات موقعك بدقة، وتصميم أنظمة رفوف مخصصة حسب المساحة ونوع المنتجات، لتحقيق أقصى استفادة ممكنة من المكان.",
    card2Title: "تصنيع رفوف بجودة عالية",
    card2Desc: "نصنع رفوف المستودعات والسوبر ماركت بمعايير عالية من المتانة والتحمل، باستخدام مواد قوية تدوم طويلاً وتتناسب مع مختلف أنواع التخزين.",
    card3Title: "توريد وتجهيز مستودعات",
    card3Desc: "نقوم بتوريد كافة مكونات أنظمة التخزين وتوفيرها في الوقت المحدد، مع تجهيز كامل لموقع العميل لضمان تركيب سلس ومنظم.",
    card4Title: "تركيب احترافي للرفوف",
    card4Desc: "فريقنا الفني يضمن تركيب الرفوف بدقة وكفاءة، مع مراعاة عوامل السلامة والاستقرار، لتكون منشأتك جاهزة للعمل فوراً.",
    card5Title: "القياس والتصميم حسب الطلب",
    card5Desc: "نبدأ من زيارة موقعكم وأخذ القياسات بدقة، ثم نضع تصميماً هندسياً يتناسب مع طبيعة نشاطكم ومساحة المستودع.",
    card6Title: "أنظمة تخزين متكاملة",
    card6Desc: "نوفر حلول تخزين مخصصة تلبي احتياجات المصانع والشركات بمستوى عالٍ من الكفاءة والتنظيم.",
    pageTitle: "خدمات ابراج الرفوف",
    pageDesc: "حلول تخزين متكاملة للمستودعات والمصانع والمحلات التجارية",
    talkServicesEyebrow: "للاستفسار عن الخدمات",
    talkToUs: "تحدث معنا",
    talkDesc: "هل لديك أي أسئلة؟ نحن دائماً على استعداد للحديث عن عملك، ومشاريعك الجديدة، والفرص الإبداعية، وكيف يمكننا مساعدتك.",
    contactButton: "اتصل بنا",
    whatsappButton: "واتساب",
  },
  about: {
    label: "",
    line1: "المزود الرائد",
    line2: "لأنظمة التخزين الصناعية",
    line3: "في المملكة العربية السعودية",
    subtitle: "نخدم كل مناطق المملكة",
    servicesButton: "تعرف على خدماتنا",
    pageTitle: "عن ابراج الرفوف",
    companyDesc: "شركة ابراج الرفوف هي شركة سعودية متخصصة في تجهيز وتركيب رفوف المستودعات ومحلات السوبر ماركت والأسواق التجارية. نقدم حلولاً عملية ومبتكرة لتنظيم المساحات وتحسين كفاءة العمل، من خلال أنظمة رفوف متينة، مصممة حسب احتياجات العميل، ومركبة بأيدٍ خبيرة.",
    visionTitle: "رؤيتنا",
    visionDesc: "أن نكون الخيار الأول في تجهيز المستودعات وأنظمة الرفوف في المملكة.",
    goalsTitle: "أهدافنا",
    goalsList: [
      "تقديم حلول تخزين عملية وفعالة لكل عميل حسب احتياجه",
      "بناء علاقات طويلة الأمد مع عملائنا مبنية على الثقة والرضا",
      "تحسين كفاءة المساحات التشغيلية في المستودعات والمحلات التجارية",
      "الابتكار المستمر في تصاميم وأنظمة الرفوف بما يواكب متطلبات السوق",
    ],
    historyTitle: "تاريخنا",
    historySubtitle: "سنوات من الرحلة",
    historyDesc: "منذ تأسيسنا، ونحن نسعى جاهدين لتقديم أفضل حلول التخزين في المملكة العربية السعودية. مع كل مشروع ننجزه، نبني سمعة قوية مبنية على الجودة والاحترافية.",
    whyTitle: "لماذا تختار ابراج الرفوف؟",
    whyCards: [
      {
        title: "تصميم ذكي",
        desc: "نقدم لك أنظمة رفوف مصممة بعناية لتحقيق أقصى استفادة من المساحة، سواء في المستودعات الكبيرة أو البقالات الصغيرة.",
      },
      {
        title: "دعم مميز",
        desc: "فريقنا متواجد دائماً للرد على استفساراتك، وتقديم استشارات فنية، ودعم ما بعد البيع، لضمان تجربة مريحة وسلسة من البداية للنهاية.",
      },
      {
        title: "تنفيذ احترافي",
        desc: "نعتمد على فريق فني متخصص في التركيب، يعمل وفق أعلى معايير الجودة والسلامة.",
      },
      {
        title: "أسعار تنافسية",
        desc: "نقدم أفضل جودة ممكنة مقابل أسعار مدروسة، بدون التنازل عن الاحترافية.",
      },
    ],
  },
  testimonials: {
    label: "آراء العملاء",
    heading: "موثوق من كبار الشركات السعودية",
  },
  cta: {
    heading: "احصل على حل التخزين المخصص لك",
    desc1: "استشارة مجانية وتقييم موقع",
    desc2: "التوصيل والتركيب في جميع أنحاء المملكة العربية السعودية",
    button: "اتصل بنا",
  },
  contact: {
    pageTitle: "اتصل بنا",
    pageDesc: "تواصل معنا للحصول على استشارة مجانية وعرض سعر مخصص لمشروعك",
    phoneLabel: "رقم الجوال",
    phoneNumber: "+966 53 278 5554",
    emailLabel: "البريد الإلكتروني",
    emailAddress: "care@info.arafouf.sa",
    locationLabel: "الموقع",
    address1: "حي الجزيرة",
    address2: "الرياض، المملكة العربية السعودية",
    hoursLabel: "ساعات العمل",
    hoursValue: "السبت - الخميس: 8:00 ص - 5:00 م",
    formTitle: "أرسل استفسارك",
    dataNotice: "نجمع البيانات التي تُدخلها في هذا النموذج (الاسم، رقم الجوال، البريد الإلكتروني، المدينة، والرسالة) بهدف التواصل معك، دراسة طلبك، وتقديم عرض خدمة مناسب. لا نستخدم هذه البيانات في أي غرض غير مرتبط بالخدمة.",
    policyConsentStart: "أوافق على",
    policyConsentAnd: "و",
    policyConsentEnd: "وأقر بمعالجة بياناتي وفقًا لما ورد فيهما.",
    formErrors: {
      submit: "حدث خطأ أثناء الإرسال، يرجى المحاولة مرة أخرى.",
      network: "حدث خطأ في الاتصال، يرجى المحاولة لاحقاً.",
    },
    submitLoading: "جاري الإرسال...",
    submitButton: "إرسال",
    successMessage: "شكراً لتواصلك معنا",
    successDesc: "تم استلام طلبك بنجاح وسيتم التواصل معك قريباً",
  },
  footer: {
    brand: "ابراج الرفوف",
    tagline: "مزود حلول التخزين",
    solutionsTitle: "الحلول",
    warehouseRacking: "رفوف المستودعات",
    retailShelving: "رفوف التجزئة",
    supermarketSystems: "أنظمة السوبر ماركت",
    customProjects: "مشاريع مخصصة",
    contactTitle: "اتصل بنا",
    phone: "+966 53 278 5554",
    email: "care@info.arafouf.sa",
    locationTitle: "الموقع",
    address1: "حي الجزيرة",
    address2: "الرياض، المملكة العربية السعودية",
    newsletterTitle: "ابق على اطلاع",
    newsletterPlaceholder: "عنوان بريدك الإلكتروني",
    newsletterButton: "اشترك",
    socialLinkedIn: "لينكدإن",
    socialInstagram: "إنستغرام",
    socialTwitter: "تويتر",
    privacy: "سياسة الخصوصية",
    terms: "شروط الخدمة",
    copyright: "2025 حلول التخزين من ابراج الرفوف",
  },
  legal: {
    privacy: {
      pageTitle: "سياسة الخصوصية",
      metaTitle: "سياسة الخصوصية | ابراج الرفوف",
      metaDesc: "توضح سياسة الخصوصية في ابراج الرفوف كيفية جمع البيانات الشخصية واستخدامها وحمايتها عند استخدام موقعنا ونموذج التواصل.",
      intro: "نحن في ابراج الرفوف نلتزم بحماية خصوصيتك والتعامل مع بياناتك بمسؤولية وشفافية. باستخدامك للموقع أو تعبئة نموذج التواصل، فأنت توافق على الممارسات الموضحة في هذه السياسة.",
      updatedAt: "آخر تحديث: 9 مايو 2026",
      sections: [
        {
          title: "1. البيانات التي نقوم بجمعها",
          paragraphs: [
            "عند استخدام نموذج التواصل، قد نجمع بيانات تقدمها لنا مباشرة بهدف خدمتك بشكل أفضل.",
          ],
          bullets: [
            "الاسم الكامل",
            "رقم الجوال",
            "البريد الإلكتروني",
            "المدينة",
            "محتوى الرسالة أو الاستفسار",
            "بيانات تقنية أساسية مثل نوع المتصفح وسجلات الاستخدام لأغراض التحسين والحماية",
          ],
        },
        {
          title: "2. كيف نستخدم بياناتك",
          paragraphs: [
            "نستخدم البيانات التي نجمعها فقط للأغراض المرتبطة بالخدمة وجودة التواصل.",
          ],
          bullets: [
            "الرد على الاستفسارات وطلبات عروض الأسعار",
            "التواصل بخصوص تفاصيل الخدمة أو الزيارة الميدانية",
            "تحسين جودة الموقع وتجربة المستخدم",
            "الامتثال للمتطلبات النظامية والتنظيمية عند الحاجة",
          ],
        },
        {
          title: "3. مشاركة البيانات مع أطراف خارجية",
          paragraphs: [
            "لا نقوم ببيع بياناتك الشخصية أو تأجيرها. قد نشارك الحد الأدنى الضروري من البيانات مع مزودي خدمات تقنيين موثوقين (مثل الاستضافة أو أدوات التحليل أو الخرائط) فقط لتشغيل الموقع وتحسينه، وبما يتوافق مع هذه السياسة.",
          ],
        },
        {
          title: "4. مدة الاحتفاظ بالبيانات",
          paragraphs: [
            "نحتفظ بالبيانات للمدة اللازمة لتنفيذ الغرض الذي جُمعت من أجله أو حسب ما تفرضه الأنظمة المعمول بها، ثم يتم حذفها أو إخفاء هويتها بطريقة آمنة.",
          ],
        },
        {
          title: "5. حماية البيانات",
          paragraphs: [
            "نطبق إجراءات تنظيمية وتقنية معقولة لحماية بياناتك من الوصول غير المصرح به أو الاستخدام أو التعديل أو الإفصاح أو الإتلاف غير المشروع.",
          ],
        },
        {
          title: "6. ملفات تعريف الارتباط (Cookies)",
          paragraphs: [
            "قد يستخدم الموقع ملفات تعريف ارتباط وتقنيات مشابهة لتحليل الأداء وتحسين تجربة الاستخدام. يمكنك تعديل إعدادات المتصفح للتحكم في ملفات الارتباط.",
          ],
        },
        {
          title: "7. حقوقك",
          paragraphs: [
            "يمكنك طلب الوصول إلى بياناتك الشخصية أو تصحيحها أو طلب حذفها، وذلك ضمن الحدود النظامية المسموح بها.",
          ],
        },
        {
          title: "8. التواصل بخصوص الخصوصية",
          paragraphs: [
            "لأي استفسار متعلق بالخصوصية أو لمعالجة أي طلب متعلق ببياناتك، يمكنك التواصل معنا عبر:",
          ],
          bullets: [
            "البريد الإلكتروني: care@info.arafouf.sa",
            "الهاتف: +966 53 278 5554",
          ],
        },
      ],
    },
    terms: {
      pageTitle: "شروط الخدمة",
      metaTitle: "شروط الخدمة | ابراج الرفوف",
      metaDesc: "تحدد شروط الخدمة في ابراج الرفوف الأحكام المنظمة لاستخدام الموقع وتقديم خدمات تجهيز وتركيب أنظمة الرفوف.",
      intro: "تحكم هذه الشروط استخدامك لموقع ابراج الرفوف وخدماتنا. يرجى قراءتها بعناية قبل إرسال أي طلب أو استخدام أي من خدماتنا.",
      updatedAt: "آخر تحديث: 9 مايو 2026",
      sections: [
        {
          title: "1. قبول الشروط",
          paragraphs: [
            "باستخدام هذا الموقع أو إرسال نموذج التواصل، فإنك تقر بقبول هذه الشروط وسياسة الخصوصية ذات العلاقة.",
          ],
        },
        {
          title: "2. نطاق الخدمات",
          paragraphs: [
            "نقدم خدمات تصميم، توريد، تجهيز، وتصنيع وتركيب أنظمة الرفوف للمستودعات والمحلات التجارية حسب طبيعة المشروع والاتفاق النهائي.",
          ],
        },
        {
          title: "3. عروض الأسعار والتعاقد",
          paragraphs: [
            "أي عرض سعر عبر الموقع أو التواصل يعتبر عرضًا أوليًا غير ملزم ما لم يتم اعتماد نطاق العمل النهائي وتوقيع الاتفاق التجاري بين الطرفين.",
          ],
          bullets: [
            "الأسعار قابلة للتحديث حسب نطاق العمل النهائي",
            "مدة التنفيذ تقديرية ما لم ينص العقد على خلاف ذلك",
            "قد تُطلب دفعات مقدمة حسب نوع المشروع",
          ],
        },
        {
          title: "4. التزامات العميل",
          paragraphs: [
            "يلتزم العميل بتقديم معلومات دقيقة وتحديثها، وتوفير الوصول للموقع وقت التنفيذ، وتجهيز الموقع بما يضمن سلامة الأعمال وسرعة الإنجاز.",
          ],
        },
        {
          title: "5. التنفيذ والسلامة",
          paragraphs: [
            "نسعى لتنفيذ الأعمال وفق أفضل الممارسات المهنية ومعايير السلامة. وقد تتأثر الجداول الزمنية بعوامل خارجة عن الإرادة مثل تأخر التوريد أو ظروف الموقع.",
          ],
        },
        {
          title: "6. الملكية الفكرية",
          paragraphs: [
            "جميع المحتويات في الموقع (النصوص، الصور، التصاميم، الشعارات) مملوكة لابراج الرفوف أو مرخصة لها، ولا يجوز إعادة استخدامها دون إذن كتابي مسبق.",
          ],
        },
        {
          title: "7. حدود المسؤولية",
          paragraphs: [
            "الموقع ومحتواه يُقدمان كما هو. لا نتحمل أي مسؤولية عن أضرار غير مباشرة أو تبعية ناتجة عن استخدام الموقع، وذلك ضمن الحدود التي يجيزها النظام.",
          ],
        },
        {
          title: "8. الإلغاء أو التأجيل",
          paragraphs: [
            "تخضع سياسات الإلغاء أو التأجيل لما يتم الاتفاق عليه تعاقديًا. وقد تترتب رسوم أو تبعات تشغيلية عند الإلغاء بعد بدء التنفيذ أو التصنيع.",
          ],
        },
        {
          title: "9. النظام المعمول به",
          paragraphs: [
            "تخضع هذه الشروط لأنظمة المملكة العربية السعودية، وتختص الجهات القضائية المختصة داخل المملكة بالنظر في أي نزاع ينشأ عنها.",
          ],
        },
        {
          title: "10. التواصل",
          paragraphs: [
            "للاستفسارات القانونية أو التشغيلية المتعلقة بهذه الشروط، يمكن التواصل عبر:",
          ],
          bullets: [
            "البريد الإلكتروني: care@info.arafouf.sa",
            "الهاتف: +966 53 278 5554",
          ],
        },
      ],
    },
  },
  meta: {
    homeTitle: "ابراج الرفوف | حلول تخزين متكاملة للمستودعات والمحلات التجارية",
    homeDesc: "شركة ابراج الرفوف - نجهز مستودعك من الالف الى الياء. تصميم، قياس، تصنيع، وتركيب أنظمة تخزين احترافية للمصانع والشركات في المملكة العربية السعودية.",
    servicesTitle: "خدمات ابراج الرفوف | تصميم وتصنيع وتركيب أنظمة التخزين",
    servicesDesc: "نقدم حلول تخزين متكاملة: تصميم، تصنيع، توريد، تركيب، والقياس حسب الطلب. خبرة في رفوف المستودعات والسوبر ماركت والمحلات التجارية.",
    aboutTitle: "من نحن | شركة ابراج الرفوف السعودية",
    aboutDesc: "تعرف على شركة ابراج الرفوف - الشركة السعودية الرائدة في تجهيز وتركيب رفوف المستودعات والأسواق التجارية منذ عام 1995.",
    contactTitle: "اتصل بنا | ابراج الرفوف - استشارة مجانية",
    contactDesc: "تواصل مع ابراج الرفوف للحصول على استشارة مجانية. نقدم حلول تخزين متكاملة للمصانع والشركات في جميع أنحاء المملكة العربية السعودية.",
    thankYouTitle: "شكراً لك | تم استلام طلبك - ابراج الرفوف",
    thankYouDesc: "تم استلام طلبك بنجاح. فريق ابراج الرفوف سيتواصل معك قريباً لتقديم أفضل حلول التخزين لمشروعك.",
  },
};